var map = {
	"./decidim/avatar-multiuser.png": 4855,
	"./decidim/brands/google.svg": 78474,
	"./decidim/cc-badge.png": 32048,
	"./decidim/decidim-logo.svg": 31338,
	"./decidim/default-avatar.svg": 4635,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 9925,
	"./decidim/icons.svg": 65180,
	"./decidim/pattern.png": 20131,
	"./decidim/placeholder-card-g.svg": 90022,
	"./decidim/placeholder-card-l.svg": 18839,
	"./decidim/placeholder.jpg": 46497,
	"./decidim/remixicon.symbol.svg": 75472,
	"./decidim/vendor/leaflet/layers-2x.png": 28539,
	"./decidim/vendor/leaflet/layers.png": 48441,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 42697,
	"./decidim/vendor/leaflet/marker-icon.png": 42429,
	"./decidim/vendor/leaflet/marker-shadow.png": 72192,
	"./decidim/vendor/social-share-button/douban.svg": 87770,
	"./decidim/vendor/social-share-button/email.svg": 74005,
	"./decidim/vendor/social-share-button/facebook.svg": 69188,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 10753,
	"./decidim/vendor/social-share-button/hacker_news.svg": 13384,
	"./decidim/vendor/social-share-button/linkedin.svg": 6544,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 68261,
	"./decidim/vendor/social-share-button/pinterest.svg": 78341,
	"./decidim/vendor/social-share-button/reddit.svg": 3011,
	"./decidim/vendor/social-share-button/telegram.svg": 34393,
	"./decidim/vendor/social-share-button/tumblr.svg": 30284,
	"./decidim/vendor/social-share-button/twitter.svg": 4658,
	"./decidim/vendor/social-share-button/vkontakte.svg": 84936,
	"./decidim/vendor/social-share-button/wechat.svg": 93581,
	"./decidim/vendor/social-share-button/whatsapp.svg": 72501,
	"./decidim/vendor/social-share-button/x.svg": 26904,
	"./decidim/vendor/social-share-button/xing.svg": 47370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71539;